module.exports = __webpack_public_path__ + "static/media/funds-consumed.4f01e74f.svg";